<app-dialog-close-button class="close-button" [compact]="true" (closed)="close()"></app-dialog-close-button>
<div vng-dialog-title class="text-center">
  Are you sure you want to <br /><strong>downgrade your plan?</strong>
</div>

<div class="text-center">
  You’ll loose access to all of these features:
</div>

<vng-dialog-content class="tw-text-center">
  <!-- R13: the dialog body is centered (title + intro line), so the feature list
       is centered as a block but keeps its own left-aligned text. -->
  <ul class="tw-inline-block tw-text-left">
    <li *ngFor="let feature of features" [innerHTML]="feature"></li>
  </ul>
  <hr class="mb-2" />
</vng-dialog-content>

<vng-dialog-actions
  align="center"
  class="top-space mb-small"
  style="display:flex; justify-content:center; align-items:center; gap:15px"
>
  <button (click)="close()" vng-button variant="primary">
    {{ isGrowthPlan() ? "Keep My Growth Plan" : "Keep Starter plan" }}
  </button>
  <!-- V3-04: master rendered the downgrade action as the orange outline variant,
       not the ink-on-white secondary. -->
  <button (click)="downgradePlan()" vng-button variant="outline">
    {{ isGrowthPlan() ? "Yes, Downgrade My plan" : "Downgrade to Freemium" }}
  </button>
</vng-dialog-actions>
<!--HubSpot Call-to-Action Code -->
<div (click)="comparePlan()" class="hs-cta-wrapper text-center accent clickable" id="hs-cta-wrapper-97c4cd3f-c316-4854-9966-9b36b38062b4">
  <span class="hs-cta-node hs-cta-97c4cd3f-c316-4854-9966-9b36b38062b4" id="hs-cta-97c4cd3f-c316-4854-9966-9b36b38062b4">
    <!--[if lte IE 8]><div id="hs-cta-ie-element"></div><![endif]-->
    Compare Plans &rarr;
  </span>
</div>
<!-- end HubSpot Call-to-Action Code -->
